export enum SwitchboardEndpointsEnum {
  WHATSAPP = 'vf:WHATSAPP',
  TELEGRAM = 'vf:TELEGRAM',
  SMS = 'vf:SMS',
  ELD = 'vf:ELD',
}

export enum HandlingOptionsEnum {
  PREFERRED_DELIVERY_ENDPOINTS = 'co.vendorflow.switchboard.crossbar:preferredDeliveryEndpoints',
  EGRESS_FROM_ADDRESSES = 'co.vendorflow.switchboard.crossbar:egressFromAddresses',
  RADAR_DRIVER = 'co.vendorflow.radar:driver',
  LOCALE = 'co.vendorflow.i18n:locale',
}

export interface HandlingOptionsType {
  [HandlingOptionsEnum.PREFERRED_DELIVERY_ENDPOINTS]?: (SwitchboardEndpointsEnum | string)[]
  [HandlingOptionsEnum.EGRESS_FROM_ADDRESSES]?: string[]
  [HandlingOptionsEnum.RADAR_DRIVER]?: string
  [HandlingOptionsEnum.LOCALE]?: string
}
